<template>
  <b-form @submit.prevent="$emit('submit')">
    <b-form-group label="Nombre">
      <b-form-input v-model="origenOferta.origen" required type="text" placeholder="Nombre del origen de oferta" />
    </b-form-group>
    <botonera-edicion url-cancelar="/origenOferta" />
  </b-form>
</template>
<script>
export default {
  props: {
    origenOferta: Object,
  },
};
</script>
